import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
export default function NaverCallbackPage() {
  const [params] = useSearchParams()
  const { login } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const token = params.get('token')
    if (!token) {
      navigate('/login', { replace: true })
      return
    }
    const email = params.get('email') ?? ''
    const name = params.get('name') ?? ''
    const raw = params.get('userLevel')
    const userLevel = raw === 'STANDARD' || raw === 'PROFESSIONAL' ? raw : 'FREE'
    const admin = params.get('isAdmin') === 'true'
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      login(token, { userId: payload.sub, name: name || payload.sub, email, userLevel, admin })
    } catch {
      login(token, { userId: 'naver_user', name: name || '네이버 사용자', email, userLevel, admin })
    }
    navigate('/dashboard', { replace: true })
  }, [params, login, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">로그인 처리 중...</p>
    </div>
  )
}
